import axios from 'axios';
import { getNextScreen, decodeResponseBody, getUniqueSessionId } from '../../../utils/library';
import {
  DOCS_UPLOADED_OR_EVERIFIED_SUCCESS,
  E_VERIFY_SUCCESS,
  RESET_TRANSACTION_DETAILS,
  UPLOAD_DOC_SUCCESS,
  GET_CURRENCY_RATE,
  SET_SEARCH_TEXT,
  SET_SEARCH_BOX_VISIBILITY,
  RESET_SEARCHBOX_DETAILS,
  SET_REQUIRED_DETAILS,
  SET_DROPDOWN_TEXT_VALUE,
  SET_BENE_DETAILS,
  SET_AADHAR_DETAILS,
  SET_SAVED_AADHAR_DETAILS,
  SAVE_PLAID_PARAMS,
  DISABLE_CHATBOT,
  STORE_BENE_LIST
} from '../../../redux/action-contants';
import { handleError } from '../common-message/message-action';
import { updateTransactionDetails } from '../../actions/individual-user-flow/individual-user-flow-action';
import { API_URL, API_URL_V2, API_URL_V3 } from '../../../utils/config';
import { CMS_CACHE_DURATION, CMS_CACHING_FLAG, INDIVIDUAL, US } from '../../../utils/constants';
import { activateLoader, disableLoader } from '../../actions/ui-trigger/ui-trigger-action';
import { userDocumentsInfo } from '../user-state/user-state-action';
import { store } from '../../../store';
import toLower from 'lodash/toLower';
import get from 'lodash/get';
import moment from 'moment';
import { getFlagValue, isFlagEnabled } from '../flagsmith/flagsmith-main';
import { toggleRedirectedFromSendMoneyAction } from '../new-bene-flow';

function eVerifySuccess(data) {
  return {
    type: E_VERIFY_SUCCESS,
    data
  };
}

function getCurrencyRates(data) {
  return {
    type: GET_CURRENCY_RATE,
    data
  };
}

export function uploadDocSuccess(data) {
  return {
    type: UPLOAD_DOC_SUCCESS,
    data
  };
}

export function setRequiredFields(data) {
  return {
    type: SET_REQUIRED_DETAILS,
    data
  };
}

export function getNextScreenFromState() {
  return (dispatch, getState) => {
    try {
      const current_screen = getState().rootReducer.userFlowReducer.currentScreen;
      const screens = getState().rootReducer.userFlowReducer.screens;
      return getNextScreen(screens, current_screen);
    } catch (err) {
      dispatch(handleError(err));
    }
  };
}

export function getRemitterAccountTypeId() {
  return (dispatch, getState) => {
    try {
      const user_session = getState().rootReducer.userSessionReducer.user_session;
      const account_type_id = user_session.account_type_id;
      return account_type_id;
    } catch (err) {
      dispatch(handleError(err));
    }
  };
}

export function getAccountType() {
  return (dispatch, getState) => {
    try {
      const user_session = getState().rootReducer.userSessionReducer.user_session;
      return user_session.account_type;
    } catch (err) {
      dispatch(handleError(err));
    }
  };
}

export function resetTransactionDetails() {
  return {
    type: RESET_TRANSACTION_DETAILS
  };
}

export function updateDocsUploadedOrEverifiedSuccess(data) {
  return {
    type: DOCS_UPLOADED_OR_EVERIFIED_SUCCESS,
    data
  };
}

export function getMobileCodeByCountry(country_code) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: `${API_URL}/country/phone-code?country_code=${country_code}`,
        withCredentials: true
      });
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}

export function getRfiRequests() {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/rfi/exist`,
        withCredentials: true
      });
      return response.data.data;
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}

export function getPhoneCodesWithValidations() {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/country/phone-code`,
        withCredentials: true
      });
      return response.data.data;
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}
//Get bene by id or get bene list by destination_currency
export function getBeneficiaryByID(beneficiary_id, isNiumForexUser = false, destination_currency) {
  const url = isNiumForexUser
    ? `${API_URL}/niumForex/remitter/beneficiary?currency_code=${destination_currency}`
    : `${API_URL}/remitter/beneficiary/${beneficiary_id}`;
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: url,
        withCredentials: true
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function eVerification(docArr, formProps) {
  return async (dispatch, getState) => {
    try {
      const cpArr = [...docArr];
      let reqObj = {};
      if (formProps) reqObj = formProps;
      else {
        cpArr.forEach((doc) => {
          const { type, code, document_detail_id, values } = doc;
          let documentData, fields;
          if (getState().form.UploadIndividualFlowDocuments) {
            documentData = getState().form.UploadIndividualFlowDocuments.values;
            documentData = documentData[type];
            fields = documentData[code];
          } else if (values && Object.keys(values).length > 0) {
            fields = values;
          }
          reqObj[code] = fields;
          if (document_detail_id) {
            reqObj['document_detail_id'] = document_detail_id;
          }
        });
      }

      let data = {
        fields: reqObj
      };

      const user_session = getState().rootReducer.userSessionReducer.user_session;
      if (user_session && user_session.country_code && user_session.country_code === 'US') {
        data = {
          ...data,
          session_id: getUniqueSessionId()
        };
      }

      const countryCode = get(store.getState(), 'rootReducer.userStatusReducer.country_code', '');

      const response = await makeApiCall({
        method: 'post',
        url: `${countryCode === US ? API_URL_V2 : API_URL}/remitter/individual/e-verify`,
        withCredentials: true,
        data
      });
      if (response.data.data.document_data) {
        const docData = [];
        response.data.data.document_data.forEach((key) => {
          if (key && key.fields) {
            const k = { ...key, ...key.fields };
            docData.push(k);
          }
        });
        if (docData.length) {
          dispatch(uploadDocSuccess(docData));
          dispatch(eVerifySuccess(docData));
          dispatch(userDocumentsInfo(docData));
        }
      }
      return response;
    } catch (error) {
      if (error?.response?.status === 465) {
        return { status: error.response.status };
      }
      dispatch(handleError(error));
    }
  };
}

export function loadBeneficiaryByCurrency(destination_currency, source_currency) {
  return async (dispatch) => {
    try {
      let response;
      if (source_currency) {
        response = await makeApiCall({
          method: 'get',
          url: API_URL + '/remitter/beneficiary/dropdown',
          withCredentials: true,
          params: {
            source_currency
          }
        });
      }
      if (destination_currency && source_currency) {
        response = await makeApiCall({
          method: 'get',
          url: API_URL + '/remitter/beneficiary/dropdown',
          withCredentials: true,
          params: {
            destination_currency,
            source_currency
          }
        });
      } else if (!destination_currency && !source_currency) {
        response = await makeApiCall({
          method: 'get',
          url: API_URL + '/remitter/beneficiary/dropdown',
          withCredentials: true
        });
      }
      if (response?.data?.data) {
        // we are sure that we are going to add bene flow because there is no bene added
        // and the user will be on the transfer-money path, navigate will do nothing
        // for this reason we will have to set the flag so the the logic knows that the user is redirected from send money
        if (response.data.data.length === 0) {
          dispatch(toggleRedirectedFromSendMoneyAction(true));
        }
        dispatch(setBeneListData(response.data.data));
        return response.data.data;
      }
    } catch (error) {
      dispatch(handleError(error));
    }
    return [];
  };
}

export function is_transaction_initiated_by_beneficiary(beneficiary_id) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: `${API_URL}/remitter/beneficiary/${beneficiary_id}/is-transaction-initiated`,
        withCredentials: true
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function verifyIfscCode(params) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/routing-code/in-house-db`,
        withCredentials: true,
        params: params
      });
      if (response && response.data && response.data.data) {
        dispatch(
          updateTransactionDetails({
            remitter_bank_info: JSON.stringify(response.data.data)
          })
        );
        return response.data.data;
      }
    } catch (error) {
      dispatch(handleError(error));
    }
    return {};
  };
}

export function a2FormLink(temp_transaction_id) {
  return async (dispatch) => {
    try {
      await makeApiCall({
        method: 'get',
        url: `${API_URL}/transaction/${temp_transaction_id}/a2-form-download `,
        withCredentials: true
      });
      return;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function transactionRecieptLink(dynamicUrl, data, isNiumForexUser = false) {
  return async (dispatch) => {
    try {
      const transaction_number = data.transaction_number;
      const url = isNiumForexUser
        ? `${API_URL}/niumForex/a2Form/download/${data?.transaction_id}`
        : `${API_URL}/${dynamicUrl}`;
      if (data.transaction_id) delete data.transaction_number;
      const response = await makeApiCall({
        method: isNiumForexUser ? 'get' : 'post',
        url,
        withCredentials: true,
        responseType: 'blob', //  to accept response in blob format :- specific to axios
        data
      });
      if (response) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        let filename = 'reciept.pdf';
        if (transaction_number) {
          filename = `${data.batch_number ? data.batch_number + '_' : ''}${transaction_number}`;
          filename += `${data.transaction_id ? '_A2_form.pdf' : '.pdf'}`;
        }
        const URL = window.URL || window.webkitURL;
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        return true;
      }
      return false;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function updateRemitterMiddleName(props, reqObj) {
  return async (dispatch) => {
    dispatch(activateLoader());
    const { middle_name } = props;
    try {
      const response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/middle-name`,
        withCredentials: true,
        data: {
          middle_name: middle_name ? middle_name : '',
          ...reqObj
        }
      });
      dispatch(disableLoader());
      if (response.data && response.data.success) {
        return true;
      }
      return false;
    } catch (error) {
      dispatch(handleError(error));
      dispatch(disableLoader());
      return false;
    }
  };
}

export function loadReasonForTransfer({
  account_type,
  source_amount,
  country_code,
  beneficiary_id,
  type,
  tempTransactionId
}) {
  let transferReasonParams = {
    type: type || 'REASON_FOR_TRANSFER',
    account_type,
    beneficiary_id
  };
  if (account_type === INDIVIDUAL && source_amount && country_code) {
    transferReasonParams = {
      ...transferReasonParams,
      country_code: country_code,
      source_amount: source_amount
    };
  }
  if (tempTransactionId) {
    transferReasonParams['temp_transaction_id'] = tempTransactionId;
  }
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: API_URL + '/instarem-objects/dropdown',
        withCredentials: true,
        params: {
          ...transferReasonParams
        }
      });
      if (response && response.data && response.data.data) return response.data.data;
    } catch (error) {
      dispatch(handleError(error));
    }
    return [];
  };
}

export function everificationRequest(url, method, body) {
  return async (dispatch) => {
    try {
      const options = {
        url: API_URL + url,
        method,
        withCredentials: true
      };
      if (method.toUpperCase() === 'GET') {
        options.params = body;
      } else {
        options.data = body;
      }
      const response = await makeApiCall(options);
      if (response && response.data && response.data.success) {
        const documents = [];
        documents.push(response.data.data.documents);
        dispatch(uploadDocSuccess(documents));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
    return [];
  };
}

export function getReuterRates(data) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/reuter-rates`,
        withCredentials: true,
        data
      });
      if (response && response.data && response.data.success) {
        dispatch(
          getCurrencyRates({
            inr_usd_rate: response.data.data
          })
        );
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function setSearchText(text) {
  return (dispatch) => {
    dispatch({
      type: SET_SEARCH_TEXT,
      searchText: text
    });
  };
}
export function setShowSearchBoxVisibilty(val) {
  return (dispatch) => {
    dispatch({
      type: SET_SEARCH_BOX_VISIBILITY,
      isSearchBoxVisible: val
    });
  };
}
export function resetSearchBoxDetails() {
  return (dispatch) => {
    dispatch({
      type: RESET_SEARCHBOX_DETAILS
    });
  };
}

export function setDropdownTextValues(data) {
  return (dispatch) => {
    dispatch({
      type: SET_DROPDOWN_TEXT_VALUE,
      textValue: data
    });
  };
}

/**
 * common middleware to all axios call
 * all network call should be routed to this method
 *  */
export async function makeApiCall(options) {
  if (!['get'].includes(toLower(options.method))) {
    const csrfToken = store.getState().rootReducer.userSessionReducer.csrf_token;
    if (csrfToken) {
      if (options.data instanceof FormData) {
        options.data.append('csrf_token', csrfToken);
      } else if (Array.isArray(options.data)) {
        const data = options.data;
        options.data = { data, csrf_token: csrfToken };
      } else if (!options.data) {
        /** for urls not containing options.data like '/initial' */
        options = { ...options, data: { csrf_token: csrfToken } };
      } else {
        options.data = { ...options.data, ...{ csrf_token: csrfToken } };
      }
    }
  }
  const response = await axios(options);
  if (response.data && !options.isFlagsmithApiCall) {
    response.data = decodeResponseBody(response.data);
  }
  return response;
}

/**
 * action for setting bene details - changes due to changing dropdown of bank name
 * to searchable bank name
 * Krunal - 13 Nov 2019
 */
export const setBeneDetails = (beneDetails) => {
  return (dispatch) => {
    dispatch({
      type: SET_BENE_DETAILS,
      payload: {
        beneDetails
      }
    });
  };
};

export const setBeneListData = (data) => {
  return (dispatch) => {
    dispatch({
      type: STORE_BENE_LIST,
      data
    });
  };
};

/**
 * setting aadhar encrypted details in redux
 * @param {*} aadhardDetails
 */
export const setAadharDetails = (aadhardDetails) => {
  return (dispatch) => {
    dispatch({
      type: SET_AADHAR_DETAILS,
      payload: {
        data: aadhardDetails
      }
    });
  };
};

/**
 * setting saved aadhar details in redux
 * @param {*} aadhardDetails
 */
export const setSavedAadharDetails = (aadhardDetails) => {
  return (dispatch) => {
    dispatch({
      type: SET_SAVED_AADHAR_DETAILS,
      payload: {
        data: aadhardDetails
      }
    });
  };
};
export const setPlaidParams = (plaidParams) => {
  return async (dispatch) => {
    dispatch({
      type: SAVE_PLAID_PARAMS,
      payload: {
        plaidParams
      }
    });
  };
};
export function loadGiftOccasions({ account_type }) {
  const transferReasonParams = {
    type: 'GIFT_OCCASION',
    account_type
  };
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: API_URL + '/instarem-objects/dropdown',
        withCredentials: true,
        params: {
          ...transferReasonParams
        }
      });
      if (response && response.data && response.data.data) return response.data.data;
    } catch (error) {
      dispatch(handleError(error));
    }
    return [];
  };
}

export async function getInstapointHistory(params) {
  return makeApiCall({
    method: 'GET',
    url: `${API_URL_V2}/instapoint/history`,
    withCredentials: true,
    params
  });
}

export async function getSourceCurrencies(sourceCountryCode) {
  return makeApiCall({
    method: 'GET',
    url: `${API_URL}/public/remitter/currencies/dropdown?is_source_currency=true&country_code=${sourceCountryCode}`,
    withCredentials: true
  });
}

export function getBeneficiaryByIDBeneServiceGeneric(beneficiary_id) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: `${API_URL_V3}/remitter/beneficiary/${beneficiary_id}`,
        withCredentials: true
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

const getCurrentUTCString = () => moment.utc().format('YYYY-MM-DD HH:mm:ss');

/*
  Caching: It will check if the values is already available in localStorage,
  If available: Will check if cacheDuration is already passed && lastUpdatedDateInUTCTime (cms) flag
  value is not after the saved lastUpdated date in localStorage: Then it will return the saved data.

  Otherwise: It will call cms apis and save the data in LS with current timeStamp and currentUTCDate date.

  For CMS updates: Whenever any person changes cms: They should update the flag value: lastUpdatedDateInUTCTime in UTC format
  Date format: YYYY-MM-DD HH:mm:ss
  All dates are in UTC
*/
export async function getContentSchemaFromContentFul(contentType, title) {
  // Get the current domain
  const domain = window.location.hostname;
  const cacheKey = `${domain}-insta-ch-${contentType}:${title}`;
  const cachedData = localStorage.getItem(cacheKey);

  const { cacheDurationInHours, lastUpdatedDateInUTCTime } = getFlagValue(CMS_CACHING_FLAG) || {};
  const cachingEnabled = isFlagEnabled(CMS_CACHING_FLAG);
  const cacheDuration =
    moment.duration(cacheDurationInHours, 'hours').asMilliseconds() || CMS_CACHE_DURATION;
  const cmsLastUpdated = moment(lastUpdatedDateInUTCTime || '1970-01-01 00:00:00');

  if (cachingEnabled && cachedData) {
    const { data, timestamp, lastUpdated } = JSON.parse(cachedData);
    if (
      moment().diff(timestamp) < cacheDuration &&
      moment(lastUpdated).isSameOrAfter(cmsLastUpdated)
    ) {
      return data;
    }
  }

  try {
    const result = await makeApiCall({
      method: 'get',
      url: `${API_URL}/public/cms`,
      params: {
        content_type: contentType,
        title
      }
    });
    const data = get(result, 'data.data.fields', {});
    /* 
      Return the data immediately without blocking the queue.
      Using Promise instead of setTimeout as 
      Promises use the microtask queue, which has a higher priority
      than the macrotask queue(which is used by setTimeout)
    */
    const currentUTCDate = getCurrentUTCString();
    Promise.resolve().then(() => {
      localStorage.setItem(
        cacheKey,
        JSON.stringify({ data, timestamp: Date.now(), lastUpdated: currentUTCDate })
      );
    });

    return data;
  } catch (error) {
    return {};
  } finally {
    // this will unblock the page in any case after the method is finished executing
    store.dispatch(disableLoader());
  }
}

export function disableChatBot() {
  return {
    type: DISABLE_CHATBOT,
    data: true
  };
}

export function enableChatBot() {
  return {
    type: DISABLE_CHATBOT,
    data: false
  };
}

export function transactionStatementDownload(dateFilter, statusFilter) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/transaction/transaction-history-download`,
        withCredentials: true,
        responseType: 'blob', //  to accept response in blob format :- specific to axios
        data: {
          start_date: moment(dateFilter.startDate).format('YYYY-MM-DD'),
          end_date: moment(dateFilter.endDate).format('YYYY-MM-DD'),
          status: statusFilter
        }
      });
      if (response) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        let filename = `Instarem_History_${moment(dateFilter.startDate).format('MMYYYY')}_`;
        filename = `${filename}to_${moment(dateFilter.endDate).format('MMYYYY')}`;
        const URL = window.URL || window.webkitURL;
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        return {
          success: true,
          link
        };
      }
      return false;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getRatingInfo() {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/review-rating/rating-info`,
        withCredentials: true
      });
      return response?.data?.data;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
export function storeUserRating(data = {}) {
  return async (dispatch) => {
    dispatch(activateLoader());
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/review-rating/feedback`,
        withCredentials: true,
        data: data
      });
      dispatch(disableLoader());
      return response?.data?.success;
    } catch (error) {
      dispatch(disableLoader());
      dispatch(handleError(error));
    }
  };
}
